import { createStore } from 'vuex'
import client from '@/client'

// steps:
// 'Unterkonstruktion'
// 'Material'
// 'Schraubenart'

export const store = createStore({
  state: {
    categories: [],
    products: [],
    currentStep: 'Unterkonstruktion',
    catIdUnterkonstruktion: null,
    catIdMaterial: null,
    catIdSchraubenart: null,
    currentProduct: null,
    currentCustomer: null,
    cart: []
  },
  mutations: {
    setProducts (state, val) {
      state.products = val
    },
    setCategories (state, val) {
      state.categories = val
    },
    setCurrentStep (state, val) {
      state.currentStep = val
    },
    setCatIdUnterkonstruktion (state, val) {
      state.catIdUnterkonstruktion = val
    },
    setCatIdMaterial (state, val) {
      state.catIdMaterial = val
    },
    setCatIdSchraubenart (state, val) {
      state.catIdSchraubenart = val
    },
    setCurrentCustomer (state, val) {
      state.currentCustomer = val
    },
    setCurrentProduct (state, val) {
      state.currentProduct = val
    },
    createOrUpdateLineItemInCart (state, val) {
      let cart = state.cart
      let foundVariation = cart.find(lineItem => lineItem.id === val.id)
      if (foundVariation) {
        foundVariation.quantity += val.quantity
      } else {
        cart.push(val)
      }
    },
    removeFromCart (state, val) {
      state.cart = state.cart.filter(lineItem => lineItem !== val)
    },
    updateQuantityInCart (state, val) {
      let lineItem = state.cart.find(lineItem => lineItem.id === val.variationId)
      lineItem.quantity = val.quantity
    }
  },
  getters: {
    filteredProducts (state) {
      if (state.catIdUnterkonstruktion && state.catIdMaterial && state.catIdSchraubenart) {
        return state.products.filter(prod =>
          prod.category_ids.includes(state.catIdUnterkonstruktion) &&
          prod.category_ids.includes(state.catIdMaterial) &&
          prod.category_ids.includes(state.catIdSchraubenart)
        )
      }
      console.log()
      return state.products
    }
  },
  actions: {
    async setProducts({commit}) {
      try {
        const res = await client.get(`/public/items/products?per_page=10000`)
        if (res) {
          let products = []
          res.data.resources.forEach(prod => {
            prod.data.category_ids = []
            prod.data.categories.forEach(cat => {
            prod.data.category_ids.push(cat.id)
            })
            const drawingTable = prod.data.attributes.find(arr => arr.name === 'drawingTable')
            if (drawingTable) {
              prod.data.drawingTable = drawingTable.options[0]
            }
            const preDrillingTable = prod.data.attributes.find(arr => arr.name === 'preDrillingTable')
            if (preDrillingTable) {
              prod.data.preDrillingTable = preDrillingTable.options[0]
            }
            const approvalsTable = prod.data.attributes.find(arr => arr.name === 'approvalsTable')
            if (approvalsTable) {
              prod.data.approvalsTable = approvalsTable.options[0]
            }
            const minLong = prod.data.attributes.find(arr => arr.name === 'minLong')
            if (minLong) {
              prod.data.minLong = minLong.options[0]
            }
            const maxLong = prod.data.attributes.find(arr => arr.name === 'maxLong')
            if (maxLong) {
              prod.data.maxLong = maxLong.options[0]
            }
            const secondImage = prod.data.attributes.find(arr => arr.name === 'secondImage')
            if (secondImage) {
              prod.data.secondImage = secondImage.options[0]
            }
            const approvalDrawing = prod.data.attributes.find(arr => arr.name === 'approvalDrawing')
            if (approvalDrawing) {
              prod.data.approvalDrawing = approvalDrawing.options[0]
            }
            const menuOrder = prod.data.menu_order
            if (menuOrder) {
              prod.data.menuOrder = menuOrder
            }

            products.push(prod.data)
          })
          commit('setProducts', products)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async setCategories({commit}) {
      try {
        const res = await client.get(`/public/items/categories?per_page=10000`)
        if (res) {
          let categories = []
          res.data.resources.forEach(cat => {
            cat.isSelected = false
            categories.push(cat.data)
          })
          commit('setCategories', categories)
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
})

export default store